module.exports = __webpack_public_path__ + "img/Group 8.8e46a321.svg";